<template>
  <b-form @submit.stop.prevent="onSubmit">
    <div
      class="position-relative my-4"
      v-if="isComment && Boolean(commentToEdit.pub.black_word.length)"
    >
      <b-icon
        icon="exclamation-circle-fill"
        variant="warning"
        class="position-absolute mt-1"
      ></b-icon>
      <div class="mb-3 ml-4">
        Mot de la liste noire détecté, svp veuillez modifier votre message
      </div>
    </div>

    <b-form-group
      v-if="!isComment"
      id="btn-radios-1"
      name="radios-btn-default"
      class="text-center"
    >
      <b-form-radio
        button
        size="sm"
        v-model="form.type"
        name="some-radios"
        :value="1"
        button-variant="outline-success"
        >{{ typeMap[1].text }}</b-form-radio
      >
      <b-form-radio
        button
        size="sm"
        v-model="form.type"
        name="some-radios"
        :value="2"
        button-variant="outline-danger"
        >{{ typeMap[2].text }}</b-form-radio
      >
      <b-form-radio
        button
        size="sm"
        v-model="form.type"
        name="some-radios"
        :value="3"
        button-variant="outline-purple"
        >{{ typeMap[3].text }}</b-form-radio
      >
    </b-form-group>

    <b-form-group invalid-feedback="Ceci est un champ requis.">
      <b-form-textarea
        autofocus
        id="textarea"
        rows="5"
        max-rows="6"
        :placeholder="`${typeMap[form.type].text}...`"
        :value="$v.form.comment.$model"
        @change="setValue('comment', $event)"
        :state="validateState('comment')"
        @keyup="charCount($event)"
        :maxlength="255"
      ></b-form-textarea>
      <b-progress
        height="3px"
        class="progress"
        :value="(totalcharacter * 100) / 255"
      ></b-progress>
      <span class="float-right px-2 pt-2">
        {{ 255 - totalcharacter }} caractères restants
      </span>
    </b-form-group>
    <b-form-group
      label="URL de la source"
      invalid-feedback="Ceci est un champ requis et doit-être un URL valid. ex. http://www.example.com"
    >
      <b-form-input
        :value="$v.form.url.$model"
        @change="setValue('url', $event)"
        :state="validateState('url')"
      ></b-form-input>
    </b-form-group>

    <div class="d-flex justify-content-between">
      <b-btn pill @click="closeParent()">
        Annuler
      </b-btn>
      <b-btn
        pill
        variant="primary"
        type="submit"
        :disabled="callComment == 'fetching'"
        >{{ isComment ? "Enregistrer" : "Enregistrer" }}
        <b-spinner class="ml-2" small v-if="callComment == 'fetching'"
      /></b-btn>
    </div>
  </b-form>
</template>

<script>
/**
 * @file       Comment form component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { required, url } from "vuelidate/lib/validators";
import { commentsMixin } from "@/modules/comments/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "commentForm",
  mixins: [commentsMixin],

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      form: {
        type: 1,
        comment: null,
        url: null
      },
      totalcharacter: 0
    };
  },

  /**
   * Vuelidate form validations.
   * 
   * @type  {Object}
   */
  validations: {
    form: {
      comment: { required },
      url: { url }
    }
  },
  mounted() {
    this.form.comment = this.commentToEdit.pub.comment;
    this.form.url = this.commentToEdit.pub.url;
  },
  destroyed() {
    this.$store.commit("deliberations/setPubToEdit", {
      pub: {},
      mode: null
    });
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    /**
     * Check if is a comment.
     *
     * @return     {bool}  true or false.
     */
    isComment() {
      return Boolean(this.commentToEdit.pub.id);
    },

    /**
     * Format the payload.
     */
    formatPayload() {
      const payload = {};
      payload.comment = this.form.comment;
      payload.url = this.form.url;

      if (this.isComment) {
        payload.id = this.commentToEdit.pub.id;
      } else {
        payload.deliberation = this.dlibr.id;
        payload.type = this.form.type;
        payload.answer_to = this.$route.params.id;
      }

      return payload;
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Sets the form value.
     *
     * @param      {string}  key     The new value
     * @param      {string}  value   The value
     */
    setValue(key, value) {
      this.form[key] = value;
      this.$v.form[key].$touch();
    },

    /**
     * Validate the form state.
     *
     * @param      {string}  name    The input name
     *
     * @return     {bool}  Dirty or not.
     */
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },

    /**
     * Close parent.
     */
    closeParent() {
      this.$emit("postSucceded", null);
    },

    /**
     * Create.
     */
    create() {
      this.submitDisabled = true;
      this.$store.commit("comments/setFlowDlibr", {
        reset: true,
        fields: { goLastComment: true }
      });
      this.$store
        .dispatch("comments/postComment", this.formatPayload)
        .then(res => {
          this.submitDisabled = false;
          this.$root.$bvToast.toast(`Publication créée avec succès`, {
            title: "Succès"
          });
          this.$emit("postSucceded", res);
        })
        .catch(err => {
          this.submitDisabled = false;
          this.$emit("postFailed", err);

          this.$notify.danger(
            err.response.data.error || err.response.data.detail
          );
        });
    },

    /**
     * Update.
     */
    update() {
      this.submitDisabled = true;
      this.$store
        .dispatch("comments/putComment", this.formatPayload)
        .then(res => {
          this.$store;
          this.updateStetaComment().then(() => {
            this.submitDisabled = false;
            this.$root.$bvToast.toast(`Publication mise à jour avec succès`, {
              title: "Succès"
            });
            this.$emit("postSucceded", res);
          });
        })
        .catch(err => {
          this.submitDisabled = false;
          this.$emit("postFailed", err);
          this.$notify.danger(
            err.response.data.error || err.response.data.detail
          );
        });
    },
    /**
     * Called on submit.
     */
    onSubmit() {
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        return;
      }

      this.isComment ? this.update() : this.create();
    },

    /**
     * Character count.
     *
     * @param    {Object}   event   The object
     */
    charCount(event) {
      this.totalcharacter = event.target.value.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.progress {
  margin-top: -1.5px;
}
</style>
